import styled from 'styled-components'
import { Flex } from 'vvs-uikit'

export const QuestTopSectionFlex = styled(Flex)`
  background-image: url('/images/vvsGotchi/bg_three_colors.png');
  background-size: cover;
  background-position: center;
  flex-direction: column;
  padding-bottom: 4em;
`
